import { Debt } from '../../interfaces/';

export const isOpen = (debt: Debt): boolean => !debt.dateClosed;
